import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./styles.css";
import Home from "./pages/Home";
import About from "./pages/About";
import BlogPage from "./pages/BlogPage";
import HomeSchool from "./pages/HomeSchool";
import Library from "./pages/learn/Library";
import SoftwareSystems from "./pages/SoftwareSystems";
import ExperiencesPage from "./pages/ExperiencesPage";
import GenericLearning from "./pages/learn/GenericLearning";
import PDSupport from "./pages/PDSupport";
import TeamMembers from "./pages/TeamMembers";
import Yoga from "./pages/learn/yoga/Yoga";
import ClassicalIndianArts from "./pages/learn/ClassicalIndianArts";
import HathaYoga from "./pages/learn/yoga/HathaYoga";
import NadaYoga from "./pages/learn/yoga/NadaYoga";
import BhakthiYoga from "./pages/learn/yoga/BhakthiYoga";
import LifeActivities from "./pages/learn/LifeActivities";
import { routes } from "./data/path";
import U2LPage from "./pages/U2L";

const router = createBrowserRouter([
  {'path': routes.root, element: <Home />},
  {'path': routes.home2, element: <Home />},
  {'path': routes.teamMembers, element: <TeamMembers />},
  {'path': routes.sharath, element: <About />},
  {'path': routes.blog, element: <BlogPage />},
  {'path': routes.homeschool, element: <HomeSchool />},
  {'path': routes.learn, element: <GenericLearning />},
  {'path': routes.activities, element: <LifeActivities />},
  {'path': routes.pdSupport, element: <PDSupport />},
  {'path': routes.library, element: <Library />},
  {'path': routes.yoga, element: <Yoga />},
  {'path': routes.hathaYoga, element: <HathaYoga />},
  {'path': routes.nadaYoga, element: <NadaYoga />},
  {'path': routes.bhakthiYoga, element: <BhakthiYoga />},
  {'path': routes.culturalArts, element: <ClassicalIndianArts />},
  {'path': routes.softwaresystems, element: <SoftwareSystems />},  
  {'path': routes.experiences, element: <ExperiencesPage />},
  {'path': routes.wayOfLife, element: <ExperiencesPage />},
  {'path': routes.initiatives, element: <Home />},  
  {'path': '/u2l', element: <U2LPage />}
])

export default function App() {
  return (<RouterProvider router={router}/>
  );
}
